module.exports = __webpack_public_path__ + "static/img/17.39cf24e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/17.jpg
// module id = /8Ex
// module chunks = 0